import {
  takeLatest, put, call, select, delay, all,
} from 'redux-saga/effects';
import dayjs from 'dayjs';
import {
  setCities,
  setSelectedCity,
  setActiveModalAction, loaderAction, initSuccessAction, authSuccess, setOrderDeliveryZoneData,
  fetchZone, fetchZones, setZones,
  clearOrderPricesPromocode,
  setOrderDeliveryZone,
} from '../actions';
import { restUrls } from '../constants';
import { fromStore } from '../selectors';
import {
  checkTimeWorkZone,
  getCookie,
  request,
  setCookie,
} from '../utils';
import { updateCurrentUser } from './auth';

export function* fetchCitiesHandler() {
  const cities = yield call(request, { method: 'get', url: restUrls.cities });
  yield put(setCities(cities));
}

export function* fetchZoneHandler({ payload: id }) {
  if (id) {
    yield put(loaderAction({ field: 'zone', value: true }));
    const zone = yield call(request, { method: 'get', url: `${restUrls.zone}/findZone/${id}` }, false);
    yield put(setOrderDeliveryZone(zone.id));
    yield put(setOrderDeliveryZoneData(zone));
    yield delay(1000);
    yield put(loaderAction({ field: 'zone', value: false }));
  }
}

function* filterZonesByTime(zonesList, city, timeMethod, selectedTime = null) {
  const zoneChecks = yield all(zonesList.map((zone) => call(checkTimeWorkZone, {
    city,
    timeMethod,
    selectedTime,
    zoneData: zone,
  })));
  return zonesList.filter((zone, index) => {
    const checkZone = zoneChecks[index];
    return checkZone && !checkZone.notWork;
  });
}

export function* fetchZonesHandler({ payload: city }) {
  yield put(loaderAction({ field: 'zones', value: true }));

  try {
    const zones = yield call(request, { method: 'get', url: `${restUrls.zone}`, params: { city: city.id } });
    let workedZones = yield call(filterZonesByTime, zones, city, 'fast');

    if (!workedZones || workedZones.length === 0) {
      const time = dayjs().add(1, 'day')
        .hour(12)
        .minute(0)
        .second(0)
        .millisecond(0);
      workedZones = yield call(filterZonesByTime, zones, city, 'time', time);
    }

    yield put(setZones(workedZones));
  } finally {
    yield put(loaderAction({ field: 'zones', value: false }));
  }
}

function* onSetCityCookie({ payload: city }) {
  const user = yield select(fromStore.userSelector);
  if ((user && !user.city) || (user && user.city && user.city.id !== city.id)) {
    yield put(loaderAction({ field: 'city', value: true }));

    const updatedData = {
      privateHouse: false,
      city: city.id,
      area: null,
      street: null,
      house: null,
      room: null,
      entrance: null,
      floor: null,
      points: null,
      zone: null,
      coords: null,
    };
    yield updateCurrentUser(updatedData);
  }
  const cityId = yield getCookie('city');
  if (+cityId !== city.id) {
    yield setCookie('city', city.id);
  }
  yield put(setActiveModalAction({ field: 'city', value: false }));
  yield put(clearOrderPricesPromocode());
  yield put(loaderAction({ field: 'city', value: false }));
}

function* initCity() {
  const user = yield select(fromStore.userSelector);
  const cities = yield select(fromStore.citiesListSelector);

  const cityCookieId = yield getCookie('city');
  const userCityId = user && user.city ? user.city.id : null;

  const cityId = userCityId || cityCookieId;

  if (!cityId) {
    yield put(setActiveModalAction({ field: 'city', value: true }));
  } else {
    const findedCity = cities.find((city) => city.id === +cityId);
    if (findedCity) {
      yield put(setSelectedCity(findedCity));
    } else {
      yield put(setActiveModalAction({ field: 'city', value: true }));
    }
  }
}

export default [
  takeLatest(setSelectedCity, onSetCityCookie),
  takeLatest(initSuccessAction, initCity),
  takeLatest(authSuccess, initCity),
  takeLatest(fetchZone, fetchZoneHandler),
  takeLatest(fetchZones, fetchZonesHandler),
];
